import React from "react";

import productService from "../services/productService";

import { showProcess, hideProcess, UserSession } from "../utils/util";
import { Galleria } from "primereact/galleria";
import Banner001 from "../img/Banner001.png";

import { useParams } from "react-router-dom";
import { InputNumber } from "primereact/inputnumber";
import shoppingCartService from "../services/shoppingCartService";
import userService from "../services/userService";
import { Checkbox } from "primereact/checkbox";

export default class Brands extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        
    }

    render() {
        
        return (
            <div
                style={{
                    overflowX: "hidden",
                    width: "100%",
                    boxSizing: "border-box",
                }}
            >
                <div style={{width: "100%", 
                             backgroundColor: "var(--unnamed-color-411172)", 
                             color: "#ffffff", 
                             padding: "30px", 
                             marginBottom: "30px", 
                             borderRadius: "0px", 
                             fontSize: "53px", 
                             fontWeight: "600",
                             textAlign: "left"}}
                        className="header-category-mobile">
                    MARCAS
                </div>
                
                <img src={require("../img/brands.png")}  style={{width: "100%", marginBottom: "100px"}}/>
            </div>
        );
    }   
}
